// Server-side Gemini client. Calls the suggest-journal Edge Function so that
// the GEMINI_API_KEY never reaches the browser.
//
// The "AI Suggest" buttons rely on isGeminiAvailable() — which is now a check
// for whether real Supabase is wired up, not whether a key is in the bundle.

import { supabase, IS_LOCAL_DEMO } from './supabase';

export function isGeminiAvailable(): boolean {
  return !IS_LOCAL_DEMO;
}

export interface SuggestedJournal {
  debit_account: string;
  credit_account: string;
  amount?: number;
  description?: string;
  reasoning?: string;
}

interface AccountForPrompt {
  gl_code: string;
  name: string;
  type: string;
}

export async function suggestJournalEntry(args: {
  description: string;
  accounts: AccountForPrompt[];
  industry?: string | null;
}): Promise<SuggestedJournal | null> {
  if (!isGeminiAvailable()) return null;
  if (!args.description.trim()) return null;

  try {
    const { data, error } = await supabase.functions.invoke('suggest-journal', {
      body: {
        description: args.description,
        accounts: args.accounts,
        industry: args.industry ?? null,
      },
    });
    if (error) {
      console.warn('[suggest-journal] error', error);
      return null;
    }
    if (!data?.debit_account || !data?.credit_account) return null;
    return data as SuggestedJournal;
  } catch (e) {
    console.warn('[suggest-journal] fetch failed', e);
    return null;
  }
}
